import React, { Component } from 'react';


import WorkPlaces from './WorkPlaces';
import WorkFlows from './WorkFlows';
import WorkFlowsAll from './WorkFlowsAll';
import WorkFlowsWorkersAll from './WorkFlowsWorkersAll';

import Sources from '../f-Utilities/Sources'

class Work extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: "work_places",
    };
  }

  select = (selection) => {
    this.setState({selected: selection})
  }

  render() {
    return(
          <div className="row content mt-5 mb-5">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">emploi</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 line-border">
                    <p
                    className={this.state.selected === "work_places" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                       onClick={this.select.bind(this, "work_places")}>lieux d'emplois </p>
                     <p
                     className={this.state.selected === "work_flows" ?
                       "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                        onClick={this.select.bind(this, "work_flows")}>flux domicile → travail <i>(détail par commune)</i> </p>
                     <p
                     className={this.state.selected === "work_flows_all" ?
                       "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                        onClick={this.select.bind(this, "work_flows_all")}>flux domicile → travail <i>(vue d'ensemble)</i></p>
                      <p
                      className={this.state.selected === "work_flows_workers_all" ?
                        "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                         onClick={this.select.bind(this, "work_flows_workers_all")}>flux domicile → travail <i>(visiteurs)</i></p>

                  </div>

                </div>
            </div>

            <div className="col-9">
                {this.state.selected == "work_places" ? <WorkPlaces territory={this.props.territory} id="work_detailed" /> :
                 this.state.selected == "work_flows" ? <WorkFlows territory={this.props.territory} id="work_flows_detailed" /> :
                 this.state.selected == "work_flows_all" ? <WorkFlowsAll territory={this.props.territory} id="work_flows_all_detailed" /> :
                 <WorkFlowsWorkersAll territory={this.props.territory} id="work_flows_workers_all_detailed" />
              }

              <div className="row mt-1">
                <div className="col-10">
                  <Sources sources={this.props.territory.sources}
                  concerned={["dossier_complet", "mobpro"]}/>
                </div>
                </div>
            </div>

          </div>
    )
  }
}

export default Work;
